var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.current == _vm.index ? 'buttonTransition vipListItem active' : 'buttonTransition vipListItem',on:{"click":_vm.toClick}},[_c('img',{style:(_vm.level <= _vm.user.level ? 'filter:none !important;' : ''),attrs:{"src":_vm.icon}}),_c('span',{domProps:{"textContent":_vm._s(_vm.name)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }